import LayersAccordion from '@/components/blocks/layers_accordion/LayersAccordion';

export default async function LayersAccordionData({ block, position }) {
  const data = block.layers_accordion.reference[0];

  return <LayersAccordion block={data} position={position} />;
}
